import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ordersData: undefined,
  ordersDataByNumber: undefined,
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    getOrdersData: (state, action) => {
      state.ordersData = action.payload;
    },
    getOrdersDataByNumber: (state, action) => {
      state.ordersDataByNumber = action.payload;
    },
  },
});

export const { getOrdersData, getOrdersDataByNumber } = ordersSlice.actions;

const ordersReducer = ordersSlice.reducer;

export default ordersReducer;
